/** @jsxImportSource @emotion/react */
import React from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { RangeKey } from './dashboard-helpers'

type Props = {
    value: RangeKey
    onChange: (value: RangeKey) => void
}

export const DashboardRangePicker: React.FC<Props> = ({ value, onChange }) => {
    const { t } = useTranslation()
    const options: { key: RangeKey; label: string }[] = [
        { key: 'last_month', label: t('TEXT_RANGE_LAST_MONTH', 'Forrige måned') },
        { key: 'last_3_months', label: t('TEXT_RANGE_LAST_3_MONTHS', 'Siste 3 måneder') },
        { key: 'current_year', label: t('TEXT_RANGE_CURRENT_YEAR', 'I år') },
        { key: 'last_year', label: t('TEXT_RANGE_LAST_YEAR', 'I fjor') },
        { key: 'last_2_years', label: t('TEXT_RANGE_LAST_2_YEARS', 'Siste 2 år') },
    ]

    return (
        <ToggleButtonGroup
            size="small"
            exclusive
            value={value}
            onChange={(_, next: RangeKey | null) => {
                if (next) onChange(next)
            }}
            aria-label={t('TEXT_DATE_RANGE', 'Datointervall')}
        >
            {options.map((option) => (
                <ToggleButton key={option.key} value={option.key}>
                    {option.label}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    )
}
